package br.com.htms.inspeccaocampo.data

object AcompAmbJson {
    fun payloadToJson(p: AcompAmbMonthPayload): String = buildString {
        append("{\"values\":{")
        p.values.entries.forEachIndexed { i, (k, v) ->
            if (i > 0) append(',')
            append(jsonStr(k))
            append(':')
            append(jsonStr(v))
        }
        append("},\"fotos\":{")
        p.fotos.entries.forEachIndexed { i, (slot, keys) ->
            if (i > 0) append(',')
            append(jsonStr(slot))
            append(":[")
            keys.forEachIndexed { j, key ->
                if (j > 0) append(',')
                append(jsonStr(key))
            }
            append(']')
        }
        append("}}")
    }

    fun payloadFromJson(raw: String): AcompAmbMonthPayload {
        val root = runCatching { JsonMap.parse(raw) }.getOrNull() ?: return AcompAmbMonthPayload()
        return payloadFromMap(root)
    }

    internal fun payloadFromMap(root: JsonMap): AcompAmbMonthPayload {
        val values = root.obj("values")?.stringValues() ?: emptyMap()
        val fotosNode = root.obj("fotos")
        val fotos = buildMap {
            if (fotosNode != null) {
                for (slot in AcompAmbSchema.allPhotoSlotKeys()) {
                    val list = fotosNode.strList(slot)
                    if (list.isNotEmpty()) put(slot, list)
                }
            }
        }
        return AcompAmbMonthPayload(values = values, fotos = fotos)
    }

    private fun jsonStr(s: String): String {
        val esc = s.replace("\\", "\\\\").replace("\"", "\\\"")
            .replace("\n", "\\n").replace("\r", "\\r").replace("\t", "\\t")
        return "\"$esc\""
    }
}
